import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';
@Pipe({
    name: 'dsiCurrency',
})
export class DsiCurrencyPipe implements PipeTransform {
    constructor(private currency: CurrencyPipe) {}
    transform(value: any, hideCentsWhenThereAreNone: boolean = false): string {
        if (hideCentsWhenThereAreNone) {
            if (parseFloat(value) === 0 || value % 1 === 0) {
                return this.currency.transform(value, 'USD', 'symbol', '1.0-0');
            }
        }
        return this.currency.transform(value);
    }
}
